<template>
	<v-dialog
		v-model="showDialog"
		max-width="600px"
		@click:outside="showDialog = false"
		:fullscreen="$vuetify.breakpoint.xs ? true : false"
		:transition="$vuetify.breakpoint.xs ? 'scroll-y-reverse-transition' : ''"
	>
		<v-card>
			<v-toolbar dark color="primary" dense flat>
				<v-toolbar-title style="color: white">部品調達依頼検索</v-toolbar-title>
				<v-spacer />
				<v-btn icon dark @click="showDialog = false" color="white">
					<v-icon>mdi-close</v-icon>
				</v-btn>
			</v-toolbar>
			<v-form class="pa-2" ref="form" lazy-validation>
				<v-row no-gutters class="mt-4">
					<v-col cols="12" sm="6">
						<v-menu
							ref="menu"
							v-model="menu1"
							:close-on-content-click="false"
							:nudge-right="40"
							transition="scale-transition"
							offset-y
						>
							<template v-slot:activator="{ on }">
								<v-text-field
									v-model="startSendDate"
									label="依頼発行日(開始)"
									readonly
									outlined
									dense
									v-on="on"
									class="px-4"
								></v-text-field>
							</template>
							<v-date-picker
								v-model="startSendDate"
								no-title
								scrollable
								locale="ja"
								@input="menu1 = false"
							>
							</v-date-picker>
						</v-menu>
					</v-col>

					<v-col cols="12" sm="6">
						<v-menu
							ref="menu"
							v-model="menu2"
							:close-on-content-click="false"
							:nudge-right="40"
							transition="scale-transition"
							offset-y
						>
							<template v-slot:activator="{ on }">
								<v-text-field
									v-model="endSendDate"
									label="依頼発行日(終了)"
									class="px-4"
									outlined
									dense
									readonly
									v-on="on"
								></v-text-field>
							</template>
							<v-date-picker
								v-model="endSendDate"
								no-title
								scrollable
								locale="ja"
								@input="menu2 = false"
							>
							</v-date-picker>
						</v-menu>
					</v-col>
					<v-col cols="12" sm="6">
						<v-menu
							ref="menu"
							v-model="menu3"
							:close-on-content-click="false"
							:nudge-right="40"
							transition="scale-transition"
							offset-y
						>
							<template v-slot:activator="{ on }">
								<v-text-field
									v-model="startAnswerDate"
									label="依頼回答日(開始)"
									readonly
									outlined
									dense
									v-on="on"
									class="px-4"
								></v-text-field>
							</template>
							<v-date-picker
								v-model="startAnswerDate"
								no-title
								scrollable
								locale="ja"
								@input="menu3 = false"
							>
							</v-date-picker>
						</v-menu>
					</v-col>
					<v-col cols="12" sm="6">
						<v-menu
							ref="menu"
							v-model="menu4"
							:close-on-content-click="false"
							:nudge-right="40"
							transition="scale-transition"
							offset-y
						>
							<template v-slot:activator="{ on }">
								<v-text-field
									v-model="endAnswerDate"
									label="依頼回答日(終了)"
									class="px-4"
									outlined
									dense
									readonly
									v-on="on"
								></v-text-field>
							</template>
							<v-date-picker
								v-model="endAnswerDate"
								no-title
								scrollable
								locale="ja"
								@input="menu4 = false"
							>
							</v-date-picker>
						</v-menu>
					</v-col>
					<v-col cols="12">
						<v-text-field
							v-model="componentName"
							class="px-4"
							outlined
							dense
							label="部品名"
						></v-text-field>
					</v-col>
					<v-col cols="12">
						<v-text-field
							v-model="productNumber"
							class="px-4"
							outlined
							dense
							label="製造番号"
						></v-text-field>
					</v-col>
				</v-row>
			</v-form>

			<v-card-actions>
				<v-col cols="4">
					<v-row no-gutters justify="start">
						<v-btn color="grey darken-1" text @click="resetForm()"> リセット </v-btn>
					</v-row>
				</v-col>
				<v-col cols="4">
					<v-row no-gutters justify="center">
						<v-btn color="primary" @click="validateAndSearch()">検索</v-btn>
					</v-row>
				</v-col>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
export default {
	props: {
		dialog: {
			type: Boolean,
			default: false,
		},
		query: {
			type: Object,
			default: () => {
				return {}
			},
		},
	},
	components: {},
	data() {
		return {
			// TODO 命名ちゃんとすること
			menu1: false,
			menu2: false,
			menu3: false,
			menu4: false,
			componentName: null,
			startSendDate: null,
			endSendDate: null,
			startAnswerDate: null,
			endAnswerDate: null,
			productNumber: null,
		}
	},
	methods: {
		validateAndSearch() {
			if (this.startSendDate > this.endSendDate) {
				this.$store.dispatch("setFlash", {
					type: "alert",
					text: "開始日は終了日以前に設定してください。",
				})
			} else if (this.startAnswerDate > this.endAnswerDate) {
				this.$store.dispatch("setFlash", {
					type: "alert",
					text: "開始日は終了日以前に設定してください。",
				})
			} else {
				this.searchRequirements()
			}
		},

		searchRequirements() {
			const params = {
				q: {
					requirement_date_gteq: this.startSendDate,
					requirement_date_lteq: this.endSendDate,
					answer_created_at_gteq: this.startAnswerDate,
					answer_created_at_lteq: this.endAnswerDate,
					requirement_values_value_target_type_name_cont: this.componentName,
					ordered_product_product_number_cont: this.productNumber,
				},
			}
			this.$emit("search-requirements", params)
		},
		resetForm() {
			this.$refs.form.reset()
		},
	},
	computed: {
		showDialog: {
			get() {
				return this.dialog
			},
			set(newVal) {
				return this.$emit("update:dialog", newVal)
			},
		},
	},
	watch: {
		query: {
			// TODO functionを使った書き方はしない
			handler: function (newVal, oldVal) {
				this.startSendDate = newVal.requirement_date_gteq
				this.endSendDate = newVal.requirement_date_lteq
				this.startAnswerDate = newVal.answer_created_at_gteq
				this.endAnswerDate = newVal.answer_created_at_lteq
				this.componentName = newVal.requirement_component_name_cont
				this.productNumber = newVal.ordered_product_product_number_cont
			},
			deep: true,
		},
	},
}
</script>
